
import Vue from 'vue';

export function httpGetHangqingList(data) {
  return  Vue.$axios({
    url: '/api/wallet/ticker/lists',
    method: 'post',
    data
  })
}

export function httpGetHangqingAll(data) {
  return  Vue.$axios({
    url: '/api/wallet/ticker/all',
    method: 'post',
    data
  })
}

export function httpAddHangqing(data) {
  return  Vue.$axios({
    url: '/api/wallet/ticker/add',
    method: 'post',
    data
  })
}

export function httpDelHangqing(data) {
  return  Vue.$axios({
    url: '/api/wallet/ticker/delete',
    method: 'post',
    data
  })
}

export function httpSortHangqing(data) {
  return  Vue.$axios({
    url: '/api/wallet/ticker/sort',
    method: 'post',
    data
  })
}

export function httpTickerBanner() {
  return Vue.$axios({
    url: '/api/wallet/ticker/banner',
    method: 'post'
  })
}